<template>
    <div class="spinner-container">
        <div class="spinner"></div>
    </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
    setup()
    {
        return;
    },
})
</script>

<style lang="scss" scoped>

@keyframes spin {
    from { transform: rotate(0); }
    to   { transform: rotate(360deg); }
}

.spinner-container {
    // Center the contained spinner vertically and horizontally
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1;

    // To make a spinner, take a square, draw a border around it, remove one of these borders
    // to create a 90° notch, and turn it into a circle using border-radius.
    & > .spinner {
        width: 1.25em;
        height: 1.25em;
        border: calc(0.08rem + 0.06em) solid $gray-200;
        border-top-color: transparent;
        border-radius: 50%;
        animation: 0.75s infinite spin linear;
    }
}

</style>
